import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const isDark = document.documentElement.classList.contains("dark")
    const opts = (icon, timer) => ({
      icon,
      timer,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      background: isDark ? "#1f2937" : "#fff",
      color: isDark ? "#f3f4f6" : undefined
    })

    const notice = this.element.querySelector("[data-flash-notice]")
    const alert = this.element.querySelector("[data-flash-alert]")

    if (notice) {
      const msg = notice.dataset.message
      if (msg && msg.length > 0) {
        window.Swal.fire({ text: msg, ...opts("success", 3000) })
      }
    }

    if (alert) {
      const msg = alert.dataset.message
      if (msg && msg.length > 0) {
        window.Swal.fire({ text: msg, ...opts("error", 5000) })
      }
    }
  }
}
